// #407: telas novas que ainda não foram concedidas a ninguém, com o botão
// "Liberar para mim". É a única exceção a "ninguém mexe nos próprios acessos"
// (regra do #174): vale só para tela ativa, criada há até 30 dias e nunca
// concedida a ninguém — o backend decide (utils/decidePrimeiraConcessao.js);
// esta lista só mostra o que ele devolve em GET /acesso/telas-novas.
//
// Só aparece para quem tem 'admin-acesso' (o mesmo gate das duas rotas). Sem
// tela nova pendente, não ocupa espaço nenhum.
import React, { useEffect, useState } from 'react';
import { MDBCard, MDBCardBody, MDBBtn, MDBIcon } from 'mdbreact';
import { toast } from 'react-toastify';
import api from '../../../services/api';
import { permissaoDeRota } from '../../../services/auth';

const dataBR = (iso) => (iso ? new Date(iso).toLocaleDateString('pt-BR') : '');

export default function TelasNovasSemAcesso() {
  const pode = permissaoDeRota('admin-acesso');
  const [telas, setTelas] = useState([]);
  const [liberando, setLiberando] = useState(null);

  useEffect(() => {
    if (!pode) return undefined;
    let vivo = true;
    api.get('/acesso/telas-novas')
      .then(({ data }) => { if (vivo) setTelas(data || []); })
      // Lista auxiliar: falhar aqui não pode atrapalhar a tela de perfis.
      .catch(() => {});
    return () => { vivo = false; };
  }, [pode]);

  if (!pode || telas.length === 0) return null;

  const liberar = async (tela) => {
    setLiberando(tela.id);
    try {
      await api.post(`/acesso/primeira-concessao/${tela.id}`);
      setTelas((ts) => ts.filter((t) => t.id !== tela.id));
      toast.success(`"${tela.nome}" liberada para você. Recarregue a página para ver no menu.`);
    } catch (e) {
      const msg = e && e.response && e.response.data && e.response.data.erro;
      toast.error(msg || 'Não foi possível liberar a tela.');
      // 409: outra pessoa liberou antes. A tela sai da lista, que já não vale.
      if (e && e.response && e.response.status === 409) {
        setTelas((ts) => ts.filter((t) => t.id !== tela.id));
      }
    } finally {
      setLiberando(null);
    }
  };

  return (
    <MDBCard className="mb-3 mt-2">
      <MDBCardBody>
        <h6 className="mb-1">
          <MDBIcon icon="star" className="mr-2 amber-text" />
          Telas novas sem acesso
        </h6>
        <p className="small text-muted mb-3">
          Telas entregues nos últimos 30 dias que ainda não foram liberadas para ninguém. Você pode liberar para si
          mesmo a primeira concessão de cada uma; os demais acessos seguem a regra normal (concedidos por outra
          pessoa). Cada liberação fica registrada e aparece no sino de quem administra acessos.
        </p>
        <table className="table table-sm mb-0" style={{ fontSize: '.9rem' }}>
          <thead>
            <tr>
              <th>Tela</th>
              <th>Módulo</th>
              <th className="text-nowrap">Criada em</th>
              <th aria-label="Ação" />
            </tr>
          </thead>
          <tbody>
            {telas.map((t) => (
              <tr key={t.id}>
                <td>{t.nome}</td>
                <td>{t.modulo}</td>
                <td className="text-nowrap">{dataBR(t.created_at)}</td>
                <td className="text-right">
                  <MDBBtn
                    size="sm"
                    color="mdb-color"
                    className="m-0"
                    disabled={liberando !== null}
                    onClick={() => liberar(t)}
                  >
                    {liberando === t.id ? 'Liberando…' : 'Liberar para mim'}
                  </MDBBtn>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </MDBCardBody>
    </MDBCard>
  );
}
